<script setup>
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { messageStamp } from 'shared/helpers/timeHelper';

import { useI18n } from 'vue-i18n';

const props = defineProps({
  inboxName: {
    type: String,
    default: '',
  },
  inboxIcon: {
    type: String,
    default: '',
  },
  scheduledAt: {
    type: Number,
    default: 0,
  },
  campaign: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();

const isCompleted = computed(
  () => props.campaign?.campaign_status === 'completed'
);

const statistics = computed(() => props.campaign?.statistics || {});

const audienceSize = computed(() => props.campaign?.audience_size || 0);
</script>

<template>
  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.SENT_FROM') }}
  </span>
  <div class="flex items-center gap-1.5 flex-shrink-0">
    <Icon :icon="inboxIcon" class="flex-shrink-0 text-n-slate-12 size-3" />
    <span class="text-sm font-medium text-n-slate-12">
      {{ inboxName }}
    </span>
  </div>

  <template v-if="!isCompleted">
    <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
      {{ t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.ON') }}
    </span>
    <span class="flex-shrink-0 text-sm font-medium text-n-slate-12">
      {{ messageStamp(new Date(scheduledAt), 'LLL d, h:mm a') }}
    </span>
    <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
      {{ t('CAMPAIGN.WHATSAPP.CARD.STATISTICS_WITH_COLON.AUDIENCE_SIZE') }}
      {{ audienceSize }}
    </span>
  </template>

  <template v-else>
    <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
      {{ t('CAMPAIGN.WHATSAPP.CARD.STATISTICS_WITH_COLON.SENT') }}
      {{ statistics.sent || 0 }}
    </span>
    <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
      {{ t('CAMPAIGN.WHATSAPP.CARD.STATISTICS_WITH_COLON.DELIVERED') }}
      {{ statistics.delivered || 0 }}
    </span>
    <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
      {{ t('CAMPAIGN.WHATSAPP.CARD.STATISTICS_WITH_COLON.READ') }}
      {{ statistics.read || 0 }}
    </span>
    <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
      {{ t('CAMPAIGN.WHATSAPP.CARD.STATISTICS_WITH_COLON.FAILED') }}
      {{ statistics.failed || 0 }}
    </span>
  </template>
</template>
